var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 188,
    viewBox: "0 0 342 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.115 45.4867L160.81 45.4862C160.209 45.4862 159.691 45.9089 159.57 46.4977L145.112 117.082C144.376 120.675 144.138 124.36 144.964 127.934C148.01 141.117 157.107 164.532 163.002 165.501L187.355 47.0069C187.516 46.222 186.917 45.4868 186.115 45.4867Z",
    fill: "#2B2B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.605 67.4237C199.795 50.652 216.905 43.596 230.253 49.0473C235.612 51.2361 238.955 56.4462 240.815 61.9283C246.398 78.3797 245.499 91.635 237.65 122.687C215.893 186.886 274.491 166.631 286.528 136.682C286.908 135.622 287.276 134.542 287.633 133.443C287.328 134.533 286.958 135.614 286.528 136.682C262.007 205.173 191.12 191.971 209.811 130.912C224.363 87.8888 224.28 47.2109 182.605 67.4237Z",
    fill: "#2B2B67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.378 5.94189L286.615 10.2274C286.098 10.3134 285.687 10.7092 285.583 11.2227L257.999 146.47C256.28 154.896 256.465 164 261.174 171.195C266.92 179.973 274.012 182.52 287 181.527C301.397 179.673 305.533 172.116 311.043 155.587C301.615 163.265 295.622 167.423 287.878 161.161C284.082 158.092 283.154 152.825 284.162 148.049L313.823 7.45134C314.007 6.5795 313.257 5.79568 312.378 5.94189Z",
    fill: "#2B2B67"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.423 47.7383C268.557 47.1667 269.067 46.7627 269.655 46.7627H279.408L277.51 57.5185H267.719C266.903 57.5185 266.301 56.7576 266.488 55.9633L268.423 47.7383Z",
    fill: "#2B2B67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.083 46.7627H323.364C324.18 46.7627 324.783 47.5236 324.596 48.3179L322.66 56.543C322.526 57.1146 322.016 57.5185 321.429 57.5185H302.185L304.083 46.7627Z",
    fill: "#2B2B67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9426 67.0092C68.0367 42.1768 83.272 61.315 91.4968 86.6228C82.3562 78.8682 76.5439 72.2831 48.4736 109.4C38.038 123.229 32.5535 132.264 31.5401 141.65C31.2221 144.595 31.4466 147.728 33.1205 150.173C38.2731 157.698 52.4723 157.418 69.9851 144.831L99.7219 123.319L106.682 148.627C76.5059 168.837 60.1381 179.279 41.5137 180.895C12.4099 184.691 -6.84338 171.405 2.28646 141.667C7.74935 123.875 15.5734 104.972 45.9426 67.0092Z",
    fill: "#2B2B67"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3311 52.4579C77.5979 32.6237 89.1275 25.0426 102.296 33.0086C106.33 35.4489 109.489 39.0907 112.028 43.0631C124.172 62.0626 129.47 87.8347 138.949 127.116C145.81 153.035 151.579 165.901 160.912 172.095C164.244 174.306 168.03 175.666 172.482 176.467C167.803 177.779 163.472 178.927 159.44 179.745C138.053 184.084 125.109 179.108 113.641 139.77C106.049 119.524 104.151 29.6808 57.3311 52.4579Z",
    fill: "url(#paint0_linear_165_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_2",
    x1: 86.8466,
    y1: 0.000676867,
    x2: 162.248,
    y2: 186.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#2C2B64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5641,
    stopColor: "#328AC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738562,
    stopColor: "#2DA1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913023,
    stopColor: "#62BDAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8b99ad7bfadbc3a84049236dd059d78f.svg";
export { ForwardRef as ReactComponent };